module.exports = __webpack_public_path__ + "static/media/Advance Steel.d48a6edb.png";